import type { HdcReport } from "../../../../../ExperianPrivateResponse.types";
import { CardRowVM, mapCreditCards } from "../mappers";
import { C, tabular } from "../theme";
import { Card } from "../shared/Card";
import { Column, DataTable } from "../shared/DataTable";
import { StatusPill } from "../shared/StatusPill";
import { UsageBar } from "../shared/UsageBar";
import { BehaviourVector, VectorLegend } from "../shared/BehaviourVector";

const columns: Column<CardRowVM>[] = [
  { key: "entity", header: "Entidad", align: "l", strong: true, render: (o) => o.entity },
  { key: "franchise", header: "Franquicia", render: (o) => o.franchise },
  { key: "class", header: "Clase", render: (o) => o.cardClass },
  { key: "account", header: "Cuenta", render: (o) => o.account, cellStyle: () => tabular },
  { key: "status", header: "Estado", render: (o) => <StatusPill {...o.status} /> },
  { key: "limit", header: "Cupo", align: "r", render: (o) => o.limit },
  {
    key: "balance",
    header: "Saldo",
    align: "r",
    render: (o) => o.balance,
    cellStyle: () => ({ color: C.white }),
  },
  { key: "available", header: "Disponible", align: "r", render: (o) => o.available },
  { key: "usage", header: "Uso", align: "l", render: (o) => <UsageBar pct={o.usagePct} /> },
  { key: "quota", header: "Cuota", align: "r", render: (o) => o.quota },
  {
    key: "overdue",
    header: "Mora",
    align: "r",
    render: (o) => o.overdue,
    cellStyle: (o) => (o.hasOverdue ? { color: C.bad, fontWeight: 600 } : undefined),
  },
  {
    key: "vector",
    header: "Comportamiento",
    align: "l",
    render: (o) => <BehaviourVector cells={o.vector} />,
  },
];

export const TarjetasTab = ({ report }: { report: HdcReport }) => (
  <Card
    flush
    title="Tarjetas de crédito"
    aside={<VectorLegend caption="Vector 24 meses, más reciente a la izquierda:" />}
  >
    <DataTable
      caption="Tarjetas de crédito"
      columns={columns}
      rows={mapCreditCards(report)}
    />
  </Card>
);
